import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { MODELS } from '../../../constants/admin/settings';
import * as actions from '../../../actions/admin/models/contract.partners';
import ContractMediaPartnerInputs from '../../../components/admin/forms/contracts/ContractMediaPartnerInputs';
import AdminModalForm from '../AdminModalForm';
import { openModalFormWithData, openModalForm } from '../../../actions/admin/modal.forms';
import { capitalize } from 'lodash';
import { PERMISSIONS, hasPermissions } from '../../../constants/authentication/permissions';
import { isSignedSelector, contractEventIdSelector, formDataSelector } from '../../../selectors/admin/models/contracts';
import { noop, get, find } from 'lodash';
import { formDataSelector as modalFormDataSelector } from '../../../selectors/admin/modal.forms';

import InfoIcon from '@material-ui/icons/Info';
import { fetchPartnerEvents } from '../../../actions/admin/models/partners';
import { requireUseUntil } from '../../../selectors/admin/models/lineup';
import { isUnlimited, toDisplayString } from '../../../lib/date.utils';
import { dependenciesSelector } from '../../../selectors/admin/forms';

class MediaPartners extends Component {
    _openContractPartner = item => {
        if (hasPermissions(this.props.user, PERMISSIONS.CONTRACTPARTNER_EDIT)) {
            this.props.openModalFormWithData(MODELS.CONTRACT_PARTNER, item);
        }
    };
    _transformRows = {
        partnerName: (_, d) =>
            get(
                find(this.props.dependencies.partners || [], x => x.id === d.partnerId),
                'name'
            ) || '',
        partnerType: (_, d) =>
            capitalize(
                get(
                    find(this.props.dependencies.partners || [], x => x.id === d.partnerId),
                    'category'
                ) || ''
            ),
        live: live => capitalize(live.replace(/_/g, ' ')),
        nonLinear: nonLinear => capitalize(nonLinear.replace(/_/g, ' ')),
        useUntil: (u, d) => (requireUseUntil(d.nonLinear) ? (isUnlimited(u) ? 'Unlimited' : toDisplayString(u)) : '')
    };
    render() {
        return (
            <React.Fragment>
                {!this.props.event ? (
                    <p className="ckp-tables-instructions">
                        <span className="ckp-tables-instructions-icon">
                            <InfoIcon />
                        </span>
                        Please select an event to populate the Media Partners
                    </p>
                ) : null}
                <AdminTable
                    subContextId={this.props.contractId || this.props.event}
                    openItem={this._openContractPartner}
                    data={this.props.contractFormData.clearing}
                    model={MODELS.CONTRACT_PARTNER}
                    forceNoSelect={this.props.isSigned}
                    canOpenRows={!this.props.isSigned}
                    buttonAction={!this.props.isSigned ? this.props.openModalForm : noop}
                    deleteAction={this.props.updateContractPartners}
                    transformFunctions={this._transformRows}
                />
                <AdminModalForm
                    title="Media Partner details"
                    staticData={this.props.contractFormData.clearing}
                    fetchDependencies={this.props.fetchContractPartnerDependencies}
                    fields={ContractMediaPartnerInputs}
                    model={MODELS.CONTRACT_PARTNER}
                    confirmLabel="Save"
                    createAction={this.props.updateContractPartners}
                    updateAction={this.props.updateContractPartners}
                    modelId={this.props.event}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    modalData: modalFormDataSelector(state, { model: MODELS.CONTRACT_PARTNER }),
    dependencies: dependenciesSelector(state),
    event: contractEventIdSelector(state),
    contractFormData: formDataSelector(state),
    isSigned: isSignedSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({ ...actions, openModalFormWithData, openModalForm, fetchPartnerEvents }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaPartners);
